import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { HeatsBracket } from 'src/components/tournaments/brackets/HeatsBracketTab';
import { BracketBoardContainer } from 'src/components/tournaments/brackets/BracketBoardContainer';

export type HeatTabsOptions = Pick<HeatsBracket, 'heats'> & {
  isDoubleElimination: boolean;
};

export const useHeatTabs = ({
  heats,
  isDoubleElimination,
}: HeatTabsOptions) => {
  const heatTabs = useMemo(() => {
    const heatsWinner = !!isDoubleElimination ? heats['winner'] : heats;

    const heatsWinnerFinal = heatsWinner?.find((heat) => {
      return heat.title === 'Final';
    });

    if (!heatsWinnerFinal) {
      return [];
    }

    const heatsLoser = !!isDoubleElimination && heats['loser'];
    const heatsLoserFinal = !!heatsLoser
      ? heatsLoser.find((heat) => {
          return heat.title === 'Final';
        })
      : undefined;

    const heatGrandFinal = !!isDoubleElimination && heats['grandFinal'][0];
    const tabGrandFinal = !!heatGrandFinal
      ? {
          name: 'Grand Final',
          content: (
            <BracketBoardContainer
              bracketLoser={heatGrandFinal}
              isGrandFinal={true}
            />
          ),
        }
      : undefined;

    const tabsFinal = [
      {
        name: 'Final',
        content: (
          <BracketBoardContainer
            bracket={heatsWinnerFinal}
            bracketLoser={heatsLoserFinal}
          />
        ),
      },
      tabGrandFinal,
    ];

    const qualifiersWinner = heatsWinner.filter((heat) => {
      return heat.title !== 'Final';
    });
    if (!qualifiersWinner?.length) {
      return tabsFinal;
    }

    const qualifiersLoser =
      !!heatsLoser &&
      heatsLoser.filter((heat) => {
        return heat.title !== 'Final';
      });
    return [
      {
        name: 'Qualifiers',
        content: qualifiersWinner.map((qualifierWinner, index) => {
          const qualifierLoser = !!qualifiersLoser
            ? qualifiersLoser[Number(index)]
            : undefined;
          return (
            <Box key={qualifierWinner[Number(index)]?.id}>
              <BracketBoardContainer
                bracket={qualifierWinner}
                bracketLoser={qualifierLoser}
              />
            </Box>
          );
        }),
      },
      {
        name: 'Final',
        content: (
          <BracketBoardContainer
            bracket={heatsWinnerFinal}
            bracketLoser={heatsLoserFinal}
          />
        ),
      },
      tabGrandFinal,
    ];
  }, [heats, isDoubleElimination]);
  return { heatTabs };
};
